import React from 'react';
import AvatarInitials from '@atlassian/jira-portfolio-3-common/src/avatar-initials/index.tsx';
import type { Props } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/view/component-slot-content/field-user-avatar-cell/types';
import { isDefined } from '@atlassian/jira-portfolio-3-portfolio/src/common/ramda';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';

export default function FieldUserAvatarCell({ title }: Props) {
	if (!isDefined(title)) {
		return null;
	}

	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		<div className={styles.container}>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<div className={styles.avatarContainer}>
				<AvatarInitials size={18} name={title} />
			</div>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<div className={styles.nameContainer}>{title}</div>
		</div>
	);
}
